import script from "./FirstGuidePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./FirstGuidePopup.vue?vue&type=script&setup=true&lang=ts"

import "./FirstGuidePopup.vue?vue&type=style&index=0&id=55b42b8d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b42b8d"]])

export default __exports__